import { GET_CANDIDATE_QUALIFY_QUESTIONS, GET_PREQUALIFYING_DETAILS } from "../Types/types";

const initialState = {
  candidateQualifyQuestions: [],
  preQualifyingDetails: null,
};

export default function qualifyQuestionsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CANDIDATE_QUALIFY_QUESTIONS:
      return { ...state, candidateQualifyQuestions: action.payload };
    case GET_PREQUALIFYING_DETAILS:
      return { ...state, preQualifyingDetails: action.payload };
    default:
      return state;
  }
}